export const HelpLink = () => {
  const HelpLinkElement = document.createElement("button");
  HelpLinkElement.type = "button";
  HelpLinkElement.className = "flex items-center gap-2 cursor-pointer";

  HelpLinkElement.innerHTML = /* html */ `
        <img src="/static/icons/settings.svg" alt="settings" class="object-contain" />

        <strong class="font-semibold text-sm text-blue-600">Precisa de ajuda?</strong>
    `;

  HelpLinkElement.addEventListener("click", () => {
    console.log("Clicou no link de ajuda");
  });

  return HelpLinkElement;
};
